import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const PersonalCare: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_501)">
                <IconPath
                    d="M9.99508 9.76768C9.05472 8.88636 7.79583 8.34998 6.44365 8.34998C3.64365 8.34998 1.24365 10.75 1.24365 13.55V15.75H3.34365L4.14365 23.25H8.64365L8.93603 20.509M6.34375 6.75C8.0006 6.75 9.34375 5.40685 9.34375 3.75C9.34375 2.09315 8.0006 0.75 6.34375 0.75C4.6869 0.75 3.34375 2.09315 3.34375 3.75C3.34375 5.40685 4.6869 6.75 6.34375 6.75ZM16.0542 23.25L10.3623 18.0943C7.26895 15.0009 11.8162 9.06162 16.0542 13.8667C20.2921 9.06162 24.8188 15.0216 21.746 18.0943L16.0542 23.25Z"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_501">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
